import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1b09ff9a")

_pushScopeId("data-v-1b09ff9a")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Download CSV ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")

  return (_ctx.canExport)
    ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "large",
        type: "primary",
        icon: "el-icon-download",
        onClick: _ctx.downloadReport
      }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick"]))
    : _createCommentVNode("", true)
})